
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(3 4)","fill":"#4788C6","fill-rule":"nonzero"}},[_c('rect',{attrs:{"x":".317","y":".351","width":"3.283","height":"15.077","rx":"1.641"}}),_c('rect',{attrs:{"x":"4.937","y":"4.311","width":"3.283","height":"11.117","rx":"1.641"}}),_c('rect',{attrs:{"x":"9.557","y":"1.8","width":"3.283","height":"13.629","rx":"1.641"}}),_c('rect',{attrs:{"x":"14.177","y":"7.8","width":"3.283","height":"7.629","rx":"1.641"}})])])
          )
        }
      }
    